import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(unix: number) {
  const d = new Date(unix * 1000);
  return d.toLocaleDateString("zh-Hant", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export function formatDuration(seconds: number) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) {
    return `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  }
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function formatTime(unix: number) {
  const d = new Date(unix * 1000);
  return d.toLocaleTimeString("zh-Hant", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

// 解析 meeting_date（YYYY-MM-DD）或 unix 時間，回傳 {month, day, year}
export function dateChip(
  meetingDate: string | null,
  createdAt: number,
): { month: string; day: string; year: string } {
  let d: Date;
  if (meetingDate) {
    // YYYY-MM-DD → 用 UTC 中午避免時區誤差
    d = new Date(meetingDate + "T12:00:00");
    if (isNaN(d.getTime())) d = new Date(createdAt * 1000);
  } else {
    d = new Date(createdAt * 1000);
  }
  return {
    month: String(d.getMonth() + 1).padStart(2, "0"),
    day: String(d.getDate()).padStart(2, "0"),
    year: String(d.getFullYear()),
  };
}
